import printMasterCashScheduleComponent from './print_master_cash_schedule.component';

let printMasterCashScheduleModule = angular.module('printMasterCashSchedule', [])

	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$stateProvider
			.state('printMasterCashSchedule', {
				url: '/print-master-cash-schedule',
				component: 'printMasterCashSchedule',
			});
	})

	.component('printMasterCashSchedule', printMasterCashScheduleComponent)

	.name;

export default printMasterCashScheduleModule;



// WEBPACK FOOTER //
// ./client/app/components/master_cash_schedule/print/index.js